<template>
    <div class="modal-container" :class="{show:showModal}">
        <div class="modal-overlay" @click="hide"></div>
        <div 
            class="modal shadow-xl" 
            :style="forcedSize" 
            :class="type"
        >
            <div class="header">
                <slot name="header"></slot>
                <i class="zmdi zmdi-close close" @click.stop="hide"></i>
            </div>
            <div class="content" style="overflow: visible">
                <slot name="content" v-if="this.showModal || !this.resetContent"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import Toolbar from '@/components/ui/Toolbar'

export default {
    name: 'UiModal',
    components: {
      Toolbar
    },
    props: {
        width: {
            type: String
        },
        height: {
            type: String
        },
        type: {
            type: String
        },
        resetContent: {
            type: Boolean,
            default: false
        },
    },
    data () {
      return {
        showModal: false,
        callbackClose: null
      }
    },
    computed: {
        forcedSize: function(){
            var style = ''
            if(this.width){
                style = style + 'width:' + this.width + ';'
            }
            if(this.height){
                style = style + 'height:' + this.height + ';'
            }
            return style
        }
    },
    methods: {
        show: function(callbackClose){
            this.callbackClose = callbackClose
            this.showModal = true;
        },
        hide: function(){
            window.Vfc.blurMode(false)
            this.showModal = false
            if(this.callbackClose){
                this.callbackClose()
            }
        }
    }
}
</script>
